import Image from 'next/image';

import { Box, Card, Icon, Paragraph, Text } from '@zillow/constellation-10';
import { IconChevronRightCircleFilled } from '@zillow/constellation-icons';

import { VERTICAL_DISPLAY_TYPE } from '../../../../constants/PropertiesConstants';

import SimpleCard from '../../../../components/SimpleCard';

import SvgTreeline from '../../../../assets/treeline-illustration.svg';

import type { UserPropertySummaryApplicationsResponseWebDto } from '@zg-rentals/ts-rental-manager-api-client';

type Props = {
  displayType?: VERTICAL_DISPLAY_TYPE;
  applicationsSummary?: UserPropertySummaryApplicationsResponseWebDto;
};

const ApplicationsSummaryCard = ({ applicationsSummary, displayType = VERTICAL_DISPLAY_TYPE.FULL }: Props) => {
  if (!applicationsSummary) {
    return null;
  }

  const {
    urlPath,
    remainingSummaryCount: { remainingCount, remainingCountNew },
  } = applicationsSummary;

  const marginBottomMediaQuery = displayType === VERTICAL_DISPLAY_TYPE.SIMPLE ? 0 : { base: '600', lg: 0, xl: '600' };

  const handleCardClick = () => {
    window.location.href = urlPath;
  };

  const cardContent = (
    <>
      <Paragraph
        css={{ textStyle: { base: 'body-sm-bold', lg: 'body-bold' } }}
      >{`+ ${remainingCount} applications...`}</Paragraph>
      {remainingCountNew > 0 ? (
        <Paragraph textStyle="body-sm" css={{ marginTop: '200', marginBottom: marginBottomMediaQuery }}>
          Includes
          <Text textStyle="body-sm-bold" css={{ color: 'text.feedback.warning.hero' }}>
            {` ${remainingCountNew} new `}
          </Text>
          applications.
        </Paragraph>
      ) : (
        <Paragraph textStyle="body-sm" css={{ marginTop: '200', marginBottom: marginBottomMediaQuery }}>
          You&apos;ve reviewed them all
        </Paragraph>
      )}

      {displayType === VERTICAL_DISPLAY_TYPE.FULL && (
        <Box css={{ display: { base: 'none', xl: 'flex' } }}>
          <Image
            src={SvgTreeline}
            alt="background"
            width={0}
            height={0}
            sizes="35px"
            style={{ position: 'relative', bottom: '10px', height: '35px', width: 'auto' }}
          />
          <Icon
            render={<IconChevronRightCircleFilled />}
            size="md"
            css={{
              color: 'icon.accent.brand.hero',
              flexGrow: 1,
              position: 'relative',
              bottom: '-2px',
              left: { base: '8px', lg: '0px' },
            }}
          />
        </Box>
      )}
    </>
  );

  if (displayType === VERTICAL_DISPLAY_TYPE.SIMPLE) {
    return (
      <SimpleCard withChevron cursor="pointer" onClick={handleCardClick}>
        {cardContent}
      </SimpleCard>
    );
  }

  return (
    <Card.Root tone="neutral" elevated={false} css={{ height: '150px', cursor: 'pointer', padding: 'none' }}>
      <Card.Body onClick={handleCardClick} css={{ padding: 'Card.Root.padding' }}>
        {cardContent}
      </Card.Body>
    </Card.Root>
  );
};

export default ApplicationsSummaryCard;
